import { Media } from '@/modules/timeline/domain/message-composer/message/media/Media';
import type { HttpMedia } from './HttpMedia';

export class MediaFactory {
  make(media: HttpMedia): Media {
    return new Media(media.id, media.content_type, media.name, media.url);
  }
}
